export const pictureMinxin1 = {
    data() {
        // 这里存放数据
        return {
            picShow: false,
            pictures: [],
            bigPic: '',
            state: 0,
            checked: 0,
            checkedPic: 0,
            changePicturesMap: [],
            isExistence: false
        }
    },
    methods: {
        add() {
            let pics = this.changePicturesMap
            if (this.checkedPic + 1 < pics.length) {
                let v = this.checkedPic + 1
                this.checkedPicPoint(pics[v], v)
            }
        },
        reduce() {
            let pics = this.changePicturesMap
            if (this.checkedPic > 0) {
                let v = this.checkedPic - 1
                this.checkedPicPoint(pics[v], v)
            }
        },
        checkedPicPoint(pic,index) {
            this.checkedPic = index
            let container = document.getElementById("photoWall")
            var elementsByClassNameElement = document.getElementsByClassName("picKuai")[index];
            // 水平滚动
            let x = elementsByClassNameElement.offsetLeft - container.clientWidth + container.clientWidth/2 + elementsByClassNameElement.clientWidth/2;
            container.scrollTo({
                left: x,
                behavior: "smooth",
            });
            this.bigPic = pic.url
        },
        init(pictures) {
            this.picShow = true
            if (pictures && pictures.length > 0) {
                this.pictures = pictures
                this.bigPic = pictures[0].url
                this.changePicturesMap = pictures
                this.isExistence = true
            }
        },
        pointLi(v) {
            this.checked = v
            this.checkedPic = 0
        },
        photoWallScroll(e) {
            e.scrollLeft = 10
        }
    },
}